import React, { useEffect } from "react";
import "./Footer.css";
import AOS from "aos";
import "aos/dist/aos.css";
import footer_logo from "../../Components/Assets/Footer_Logo.png";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaGoogle, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <footer
      className="footer text-white pt-5"
      style={{ backgroundColor: "#0F1738" }}
    >
      <div className="container">
        <div className="row gy-4">
          {/* Brand Info */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <img src={footer_logo} alt="shiny-logo" className="footer-logo" />
            <p className="small text-white-50 " style={{marginTop : '-30px'}}>
              Experience the shiny cleaning difference! Our Adelaide &
              Melbourne-based team uses safe methods to deliver deep cleaning,
              fresh air, and more free time for you to enjoy.
            </p>
          </div>

          {/* Navigation */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3">Navigation</h6>
            <ul className="list-unstyled">
              <li>
                <Link to="/about-us/" className="footer-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="footer-link">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq-page" className="footer-link">
                  Faq
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="footer-link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3">Information</h6>
            <p className="mb-1">Para Hills SA 5096</p>
            <p className="mb-1">
              <Link
                to="mailto:info@shinycleaner.com"
                className="text-decoration-none text-white"
              >
                info@shinycleaner.com
              </Link>
            </p>

            <p className="mb-0">
              <Link
                to="tel:0406958557"
                className="text-decoration-none text-white d-inline-flex align-items-center gap-2"
              >
                +61 406 958 557
              </Link>
            </p>
          </div>

          {/* Opening Hours */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3">Our Services</h6>
            <ul className="list-unstyled">
              <li>
                <Link to="/service/house-cleaning/" className="footer-link">
                  House Cleaning
                </Link>
              </li>
              <li>
                <Link to="/service/commercial-cleaning/" className="footer-link">
                  Commercial Cleaning
                </Link>
              </li>
              <li>
                <Link to="/service/window-cleaning/" className="footer-link">
                  Window Cleaning
                </Link>
              </li>
              <li>
                <Link to="/service/oven-cleaning/" className="footer-link">
                  Oven Cleaning
                </Link>
              </li>
              <li>
                <Link to="/service/carpet-cleaning/" className="footer-link">
                  Carpet Steam Cleaning
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="text-center pb-4 ">
          <p className="small mb-2 text-white-50">
            © Copyright Shiny Cleaner 2025. All Right Reserved by NODEPRIX
            TECHNOLOGY LLP
          </p>

          <div className="d-flex justify-content-center gap-3">
            <Link
              to="https://www.facebook.com/shinycleaningofficial"
              target="_blank"
              rel="noreferrer"
              className="social-icon-link-top"
            >
              <FaFacebook className="social-icon-top" />
            </Link>

            <Link
              to="https://www.google.com/maps/place/Shiny+Cleaning/@-34.8706926,138.6782561,17z/data=!3m1!4b1!4m6!3m5!1s0xa635f2ddcbe88963:0x4a7a383a4f425b24!8m2!3d-34.8706926!4d138.6782561!16s%2Fg%2F11vbsb9g4l?hl=en-IN&entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noreferrer"
              className="social-icon-top"
            >
              <FaGoogle className="social-icon-top" />
            </Link>
            <Link
              to="https://www.instagram.com/shinycleaningofficial/"
              target="_blank"
              rel="noreferrer"
              className="social-icon-link-top"
            >
              <FaInstagram className="social-icon-top" />
            </Link>
            <Link
              to="https://www.linkedin.com/company/shinycleaningofficial/"
              target="_blank"
              rel="noreferrer"
              className="social-icon-link-top"
            >
              <FaLinkedin className="social-icon-top" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
